import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Spinner from '../../../_generic/spinner/Spinner';
import BookingCalendarPackage from './BookingCalendarPackage';

const BookingCalendarRoomOnlyPackages = ({
  currency,
  isDynamicTravelGift,
  onSelect,
  onQuantityChange,
  packages,
  quantity,
  selection,
}) => {
  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    if (packages?.length > 0) {
      // select the first package
      const newPackage = packages[0];
      setSelectedPackage(newPackage);
    }
  }, [packages]);

  if (packages?.length === 0 || !selectedPackage) {
    return (
      <>
        <div className="booking-calendar--loading">
          <Spinner />
        </div>
        <style jsx>{`
          .booking-calendar--loading {
            position: relative;
            min-height: 300px;
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className="packages">
        {packages?.map((product) => (
          <BookingCalendarPackage
            currency={currency}
            isDynamicTravelGift={isDynamicTravelGift}
            key={product.dealVoucherProductId}
            onQuantityChange={onQuantityChange}
            onSelect={onSelect}
            product={product}
            quantity={quantity}
            selected={
              selection?.dealVoucherProductId === product.dealVoucherProductId
            }
          />
        ))}
      </div>
      <style jsx>{`
        .packages {
          margin-bottom: 20px;
        }
        .package-buttons {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 15px;
        }
        .package-drop-down {
          margin-bottom: 15px;
        }
      `}</style>
    </>
  );
};

BookingCalendarRoomOnlyPackages.propTypes = {
  currency: PropTypes.string,
  isDynamicTravelGift: PropTypes.bool,
  onQuantityChange: PropTypes.func,
  onSelect: PropTypes.func,
  packages: PropTypes.array,
  quantity: PropTypes.number,
  selection: PropTypes.object,
};

BookingCalendarRoomOnlyPackages.defaultProps = {
  currency: 'gbp',
  isDynamicTravelGift: false,
  onQuantityChange: () => false,
  onSelect: () => false,
  packages: [],
  quantity: 1,
  selection: null,
};

export default BookingCalendarRoomOnlyPackages;
